<template>
    <div class="rechargeResultPush-box">
        <div class="head">
            <div class="op-box">
                <el-button size="mini" type="primary" @click="add" icon="el-icon-plus">添加</el-button>
                <el-button size="mini" style="color: #E6A23C" type="text" @click="edit"><i><svg-icon style="width:1.2em; height: 1.2em; padding-left: 1rem" icon-class="修改"></svg-icon></i>&nbsp;修改</el-button>
                <el-button size="mini" style="color: #F56C6C" type="text" @click="remove"><i><svg-icon style="width:1.2em; height: 1.2em; padding-left: 1rem" icon-class="停用"></svg-icon></i>&nbsp;删除</el-button>
            </div>
        </div>
        <div class="rechargeResultPush-table-box">
            <el-table class="rechargeResultPush-table" :data="dataInfo" height="100%" width="100%" @row-click="currClick" :header-row-style="{color:'black'}" size="small" highlight-current-row>
                <el-table-column
                        align="center"
                        prop="url"
                        label="充值结果推送地址">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="authorizationToken"
                        label="客户授权码">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="timeInterval"
                        label="数据推送频率（分钟）">
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="充值结果推送设置" :visible.sync="dialogFormVisible" width="35rem" top="15vh" size="small">
            <template slot="title">
                充值结果推送设置
            </template>
            <el-form :model="newData" :rules="rules" ref="ruleForm" size="small" inline label-position="left" label-width="8rem">
                <div class="item-group">
                    <el-form-item label="充值结果推送地址" prop="alarmUrl">
                        <el-input v-model="newData.url" placeholder="请输入充值结果推送地址" autocomplete="off" style="width: 23rem"></el-input>
                    </el-form-item>
                    <el-form-item label="推送频率" prop="paramPushTimeInterval">
                        <el-select v-model="newData.timeInterval" placeholder="请选择推送频率" style="width: 23rem">
                            <el-option :key="1" :value="1" label="5分钟"></el-option>
                            <el-option :key="2" :value="2" label="15分钟"></el-option>
                            <el-option :key="3" :value="3" label="30分钟"></el-option>
                            <el-option :key="4" :value="4" label="1小时"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="item-group">
                    <el-form-item label="客户授权码" prop="authorizationToken">
                        <el-input v-model="newData.authorizationToken" placeholder="请输入客户授权码" autocomplete="off" style="width: 23rem"></el-input>
                    </el-form-item>
                </div>
            </el-form>

            <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="save">保存</el-button>
			<el-button @click="cancel">取 消</el-button>
		</span>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
import { getDataByCustmerId, saveOrUpdate, del } from "@/api/rechargeResultPush";

export default {
  name: "rechargeResultPush",
  data(){
    let checkUrl = (rule, value, callback) => {
      if(value){
        // 验证url
        var strRegex = "^((https|http)?://)" + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
          + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
          + "|" // 允许IP和DOMAIN（域名）
          + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
          + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
          + "[a-z]{2,6})" // first level domain- .com or .museum
          + "(:[0-9]{1,4})?" // 端口- :80
          + "((/?)|" // a slash isn't required if there is no file name
          + "(/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+/?)$";
        var re = new RegExp(strRegex);
        if(re.test(value)){
          callback();
        } else {
          callback(new Error('请输入正确的URL地址'));
        }
      } else {
        callback();
      }
    };
    return{
      dataInfo: [],
      flag:{
        addFlag:true,editFlag:true,removeFlag: true
      },
      dialogFormVisible: false,
      formLabelWidth: '110px',
      newData:{},
      meterTree:[],
      meterTreeChecked:[],
      meterTreeProps:{
        children: 'children',
        label: 'name'
      },
      measureTypeTree:[],
      checkedMpTypes:[],
      alarmType:[],
      rules: {
        //1、要验证url 2、验证报警类型 3、数据权限
        url: [
          /*{ required: true, message: '请输入报警推送地址', trigger: 'blur' },*/
          { validator: checkUrl, trigger: ['blur','change'] }
        ],
      }
    }
  },
  computed: {
    ...mapGetters([
      'customerId'
    ])
  },
  mounted() { /* 页面初始化完成加载数据*/
    this.fetchData()
  },
  methods: {
    cancel: function(){
      this.dialogFormVisible = false
      this.newData = {}
    },
    remove: function(){
      if(Object.keys(this.newData).length === 0){
        Message({
          message: "请选择需要删除的记录",
          type: 'warning',
          duration: 5 * 1000
        })
      }else{
        del(this.newData).then(res =>{
          if(res.code === 200){
            Message({
              message: res.message,
              type: 'success',
              duration: 5 * 1000
            })
            this.newData = {}
            this.fetchData()
          }else{
            Message({
              message: res.message,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
      }
    },
    edit: function(){
      if(Object.keys(this.newData).length === 0){
        Message({
          message: "请选择需要修改的记录",
          type: 'warning',
          duration: 5 * 1000
        })
      }else{
        this.dialogFormVisible = true;
      }
    },
    currClick: function (val) {
      let data = Object.assign({}, val)
      this.newData = {
        id: data.id,
        url: data.url,
        authorizationToken: data.authorizationToken,
        timeInterval: data.timeInterval,
        customerId: this.customerId
      }
    },
    save: function(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if(this.newData.url === "" && this.newData.url === ""){
            Message.warning("请输入推送地址")
            return
          }
          saveOrUpdate(this.newData).then(res =>{
            if(res.code === 200){
              Message({
                message: res.message,
                type: 'success',
                duration: 5 * 1000
              })
              this.newData = {}
              this.fetchData()
            }else{
              Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
              })
            }
            this.dialogFormVisible = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    fetchData: function () {
      getDataByCustmerId(this.customerId).then(res => {
        if(res.code == 200){
          this.dataInfo = res.infoJson
        }
      })
    },
    add: function() {
      if(Object.keys(this.dataInfo).length !== 0){
        Message({
          message: "每个客户仅限配置一个充值推送地址",
          type: 'warning',
          duration: 5 * 1000
        })
      }else{

        this.newData = {
          id: '',
          url : '',
          authorizationToken : '',
          timeInterval:5,
          customerId: this.customerId,
        }
        this.dialogFormVisible = true
      }
      //this.dialogFormTitle = '添加客户推送地址';
    }
  }
}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .rechargeResultPush-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .head{
            flex-direction: column;
            box-sizing: border-box;
            .collection-manage-condition-box{
                font-size: 0.875rem;
                display: flex;
                align-items: center;
                padding-top: 1%;
                padding-left: 2%;
                box-sizing: border-box;

            }
            .op-box {
                padding-left: 2%;
                padding-top: 1%;
                padding-bottom: 15px;
                /*padding-left: 1%;

                padding-bottom: 15px;*/
            }
        }
        .rechargeResultPush-table-box {
            /* overflow: auto;
             max-height: 320px;
             height: auto;
             width: auto;
             display: block;
             align-items: center;*/
            flex: 4;

        }



        .el-table .warning-row {
            background: oldlace;
        }

        .div-hr {
            height: 1px;
            background-color: #dedede;
        }
    }
</style>
